import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Devices from "@/pages/Devices";
import BatteryPage from "@/pages/BatteryPage";
import InverterPage from "@/pages/InverterPage";
import AdminPanel from "@/pages/AdminPanel";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-400">
        <Loader2 className="animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/admin"
        element={
          <Protected>
            <AdminPanel />
          </Protected>
        }
      />
      <Route
        path="/devices"
        element={
          <Protected>
            <Devices />
          </Protected>
        }
      />
      <Route
        path="/devices/:id/battery"
        element={
          <Protected>
            <BatteryPage />
          </Protected>
        }
      />
      <Route
        path="/devices/:id/inverter"
        element={
          <Protected>
            <InverterPage />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/devices" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
